import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { getTestIds } from '../../../../utils/TestIds';
import { Badge } from '../../../Badge';
import { FullRow } from '../../../Layout';
import { Switch } from '../../../Switch';
import { Typography } from '../../../Typography';
import styles from './ColumnsPanel.module.scss';
export function ColumnsPanelRow(param) {
    let { entry, frozenLabel, toggleBi, onToggleVisibility, testId } = param;
    const testIds = useMemo(()=>getTestIds(testId), [
        testId
    ]);
    const isPinnedOn = entry.isMain;
    return /*#__PURE__*/ _jsxs(FullRow, {
        alignItems: "center",
        gap: 8,
        className: styles.entry,
        testId: testIds.entry(entry.id),
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph2",
                ellipsis: true,
                className: styles.entryLabel,
                children: entry.label
            }),
            entry.frozen && /*#__PURE__*/ _jsx(Badge, {
                skin: "default",
                size: "small",
                testId: testIds.frozen(entry.id),
                children: frozenLabel
            }),
            /*#__PURE__*/ _jsx(Switch, {
                bi: toggleBi,
                checked: isPinnedOn || !entry.hidden,
                disabled: isPinnedOn,
                onChange: ()=>!isPinnedOn && onToggleVisibility(entry.id),
                testId: testIds.visible(entry.id)
            })
        ]
    });
}
